var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FlickerFree50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#546e7a",
    d: "M6,8h36v26H6V8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bbdefb",
    d: "M8,10h32v22H8V10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M21,34h6v3h-6V34z M33,37c-2,0-16,0-18,0s-2,2-2,2v1h22v-1C35,39,35,37,33,37z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 8,
    y: 12,
    fill: "#90a4ae"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 8,
    y: 16,
    fill: "#90a4ae"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 8,
    y: 20,
    fill: "#90a4ae"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 8,
    y: 24,
    fill: "#90a4ae"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 8,
    y: 28,
    fill: "#90a4ae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FlickerFree50);
export default __webpack_public_path__ + "static/media/icons8-flicker-free-50.e01c50510f1f6f6c78103cd375f3a0ec.svg";
export { ForwardRef as ReactComponent };